import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext.js';
import { billingService } from '../services/billingService.js';
import './Subscription.css';

const SparklesIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 3L13.5 8.5L19 10L13.5 11.5L12 17L10.5 11.5L5 10L10.5 8.5L12 3Z" fill="currentColor" />
    <path d="M19 4L19.5 6L21 6.5L19.5 7L19 9L18.5 7L17 6.5L18.5 6L19 4Z" fill="currentColor" />
    <path d="M19 16L19.5 18L21 18.5L19.5 19L19 21L18.5 19L17 18.5L18.5 18L19 16Z" fill="currentColor" />
  </svg>
);

const CheckIconFilled = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="currentColor" />
    <path d="M8 12L11 15L16 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CrownIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="#FFD700" stroke="#FFA500" strokeWidth="1.5" />
  </svg>
);

const TrendingUpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23 6L13.5 15.5L8.5 10.5L1 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17 6H23V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CalendarIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
    <path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const BadgeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" fill="none" />
  </svg>
);

const ChartIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="14" width="4" height="7" rx="1" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.5" />
    <rect x="10" y="8" width="4" height="13" rx="1" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.5" />
    <rect x="17" y="3" width="4" height="18" rx="1" fill="currentColor" fillOpacity="0.2" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);

const RocketIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" fill="currentColor" fillOpacity="0.15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CrownIconLarge = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="currentColor" fillOpacity="0.15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 2L15.09 8.26L22 9.27" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 2L8.91 8.26L2 9.27" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlanCard = ({ title, price, originalPrice, features, freeMonths, isSelected, isPremium, badge, icon, description, onSelect }) => {
  const getFeatureIcon = (feature) => {
    if (feature.includes('Exposição')) return <TrendingUpIcon />;
    if (feature.includes('Agendamentos')) return <CalendarIcon />;
    if (feature.includes('destaque')) return <BadgeIcon />;
    return <CheckIconFilled />;
  };

  return (
    <div
      className={`plan-card ${isSelected ? 'selected' : ''} ${isPremium ? 'premium' : ''}`}
      onClick={onSelect}
    >
      {badge && (
        <div className="plan-badge">
          <SparklesIcon />
          <span>{badge}</span>
        </div>
      )}

      <div className="plan-header">
        <div className="plan-title-row">
          <div className="plan-icon">{icon}</div>
          <div>
            <h3 className="plan-title">{title}</h3>
            {description && <p className="plan-description">{description}</p>}
          </div>
        </div>

        <div className="price-container">
          {originalPrice && <span className="original-price">{originalPrice}</span>}
          <span className="current-price">{price}</span>
        </div>

        {/* <div className="plan-pricing">
          <div className="price-container">
            {originalPrice && <span className="original-price">{originalPrice}</span>}
            <span className="current-price">{price}</span>
          </div>
          <div className="free-months">{freeMonths}</div>
        </div> */}
      </div>

      <div className="plan-divider"></div>

      <ul className="plan-features">
        {features.map((feature, index) => (
          <li key={index}>
            <span className="feature-icon">{getFeatureIcon(feature)}</span>
            <span className="feature-text">{feature}</span>
          </li>
        ))}
      </ul>

      {isSelected && (
        <div className="selected-indicator">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" fill="white" />
            <path d="M8 12L11 15L16 9" stroke="#7165FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>Plano Selecionado</span>
        </div>
      )}
    </div>
  );
};

const Subscription = ({ onClose, onSubscribe }) => {
  const [selectedPlan, setSelectedPlan] = useState('plus');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [legalModal, setLegalModal] = useState(null);
  const { user } = useAuth();

  const legalContent = {
    termsOfUse: {
      title: "Termos de Uso",
      content: "Antes de utilizar nossos serviços, é essencial que você leia atentamente e compreenda estes Termos de Uso. Ao acessar ou utilizar o aplicativo, você concorda em cumprir e se vincular a estes termos. Caso não concorde com qualquer disposição, recomendamos que não utilize o aplicativo.\n\n**1. Uso do Aplicativo**\n\n1.1. O aplicativo foi desenvolvido com o objetivo de facilitar a busca por profissionais veterinários, podendo também abranger outras áreas relacionadas.\n\n1.2. Ao utilizá-lo, você se compromete a fornecer informações verdadeiras, completas e atualizadas durante o cadastro, bem como a não criar identidade falsa nem utilizar a conta de terceiros sem autorização.\n\n1.3. As informações referentes a serviços veterinários são de responsabilidade exclusiva dos anunciantes. A Vetsse não presta nem intermedeia os serviços anunciados.\n\n1.4. Você é responsável por manter em sigilo suas credenciais de acesso. Toda atividade realizada em sua conta é de sua inteira responsabilidade.\n\n**2. Propriedade Intelectual**\n\n2.1. Todo o conteúdo do aplicativo, incluindo textos, imagens, gráficos, logotipos e softwares, é de propriedade exclusiva da empresa ou de seus parceiros.\n\n2.2. É proibida a reprodução, modificação, distribuição, exibição, transmissão, publicação, criação de obras derivadas, comercialização ou qualquer outra utilização do conteúdo sem autorização prévia e expressa por escrito.\n\n**3. Privacidade e Segurança**\n\n3.1. Prezamos pela sua privacidade e protegemos seus dados pessoais de acordo com nossa Política de Privacidade, que descreve como coletamos, utilizamos e armazenamos suas informações.\n\n3.2. Recomendamos que você adote boas práticas de segurança, como proteger suas credenciais de acesso e não compartilhar informações pessoais sem necessidade.\n\n**4. Relatórios gerados por Inteligência Artificial**\n\n4.1. O aplicativo utiliza recursos de Inteligência Artificial (IA/AI) para gerar relatórios sobre o estado de saúde geral do pet, com base nas informações fornecidas pelo usuário.\n\n4.2. Esses relatórios têm caráter estritamente informativo e educacional, não constituindo diagnóstico, prescrição, orientação clínica ou substituto de consulta com profissional veterinário habilitado.\n\n4.3. A Vetsse não garante a precisão, exatidão ou integralidade das informações geradas pela IA e não se responsabiliza por quaisquer decisões, ações ou omissões tomadas com base nesses relatórios, incluindo, mas não se limitando a, tratamentos, cuidados ou intervenções médicas adotadas pelo usuário.\n\n4.4. Recomendamos fortemente que qualquer informação apresentada pelo aplicativo seja utilizada apenas como apoio complementar e que os usuários consultem sempre um veterinário qualificado para avaliação profissional da saúde de seus animais.\n\n**5. Limitações de Responsabilidade**\n\n5.1. O aplicativo é disponibilizado 'no estado em que se encontra' e 'conforme disponível', sem garantias expressas ou implícitas quanto à precisão, confiabilidade ou adequação do conteúdo.\n\n5.2. Não nos responsabilizamos por danos diretos, indiretos, incidentais, consequenciais ou punitivos resultantes do uso ou da impossibilidade de uso do aplicativo, ainda que tenhamos sido previamente alertados sobre a possibilidade de tais danos.\n\n**6. Alterações nos Termos de Uso**\n\n6.1. Poderemos modificar ou atualizar estes Termos de Uso a qualquer momento, a nosso exclusivo critério. As alterações entrarão em vigor imediatamente após sua publicação no aplicativo.\n\n6.2. O uso contínuo do aplicativo após a publicação das alterações implicará sua aceitação integral dos novos termos.\n\n**7. Encerramento da Conta**\n\n7.1. Você poderá encerrar sua conta a qualquer momento, seguindo as instruções disponíveis no aplicativo ou entrando em contato conosco.\n\n7.2. A empresa poderá encerrar sua conta, suspender ou restringir o acesso ao aplicativo, sem aviso prévio, caso identifique violação destes Termos de Uso ou da legislação vigente.\n\n**8. Disposições Gerais**\n\n8.1. Estes Termos de Uso constituem o acordo integral entre você e a empresa, substituindo quaisquer entendimentos ou contratos anteriores, verbais ou escritos.\n\n8.2. Caso alguma disposição destes termos seja considerada inválida ou inexequível, as demais permanecerão plenamente vigentes.\n\n8.3. A omissão do exercício de qualquer direito ou disposição não constituirá renúncia ou novação.\n\n8.4. Estes Termos de Uso serão regidos e interpretados conforme as leis do país em que a empresa está sediada, sem considerar regras de conflito de leis."
    },
    privacyPolicy: {
      title: "Política de Privacidade",
      content: "Data de vigência: período de utilização do aplicativo.\n\n**Informações coletadas**\n\n1.1 Dados pessoais: Podemos coletar informações de identificação pessoal, como nome, endereço de e-mail, número de telefone e informações de contato fornecidas voluntariamente pelos usuários.\n\n1.2 Dados de uso: Podemos coletar informações sobre como o aplicativo é acessado e usado, incluindo dados sobre interações, funcionalidades utilizadas e padrões de uso.\n\n1.3 Dados de localização: Com o consentimento do usuário, podemos coletar informações de localização do dispositivo para fornecer recursos baseados em localização e melhorar a experiência do usuário.\n\n**Uso das informações**\n\n2.1 Fornecimento de serviços: Utilizamos as informações coletadas para fornecer e manter os serviços do aplicativo, responder a solicitações dos usuários, solucionar problemas técnicos e melhorar a funcionalidade do aplicativo.\n\n2.2 Personalização da experiência: Podemos utilizar as informações para personalizar a experiência do usuário, apresentando conteúdo relevante e oferecendo recursos adaptados às preferências individuais.\n\n2.3 Comunicações: Podemos utilizar as informações de contato para enviar notificações, atualizações, boletins informativos e outras comunicações relacionadas ao aplicativo. Os usuários podem optar por não receber essas comunicações a qualquer momento.\n\n2.4 Análise e melhoria: Podemos utilizar os dados coletados para análise interna, pesquisa, desenvolvimento de novos recursos e melhoria contínua do aplicativo.\n\n**Compartilhamento de informações**\n\n3.1 Compartilhamento com terceiros: Podemos compartilhar informações com provedores de serviços terceirizados que auxiliam na operação, manutenção e aprimoramento do aplicativo. Esses terceiros têm acesso limitado às informações e são obrigados a protegê-las de acordo com as leis e regulamentações aplicáveis.\n\n3.2 Consentimento do usuário: Não compartilhamos informações pessoais dos usuários com terceiros sem o consentimento expresso do usuário, exceto nos casos em que seja necessário cumprir obrigações legais, proteger direitos de propriedade ou garantir a segurança dos usuários.\n\n**Segurança dos dados**\n\nImplementamos medidas de segurança adequadas para proteger as informações dos usuários contra acesso não autorizado, divulgação ou alteração. No entanto, nenhum sistema de segurança é totalmente impenetrável, e não podemos garantir a segurança absoluta das informações fornecidas por meio do aplicativo.\n\n**Retenção de dados**\n\nRetemos as informações pessoais dos usuários apenas pelo tempo necessário para cumprir as finalidades descritas nesta política de privacidade, a menos que uma retenção mais longa seja exigida ou permitida por lei.\n\n**Direitos do usuário**\n\nOs usuários têm o direito de acessar, corrigir, atualizar ou excluir suas informações pessoais. Podem exercer esses direitos entrando em contato conosco através dos canais fornecidos no aplicativo.\n\n**Alterações nesta política de privacidade**\n\nReservamo-nos o direito de atualizar ou modificar esta política de privacidade a qualquer momento, a nosso critério. Quaisquer alterações feitas nesta política de privacidade serão publicadas nesta página com a nova data de vigência. É responsabilidade do usuário revisar periodicamente esta política para estar ciente de quaisquer alterações.\n\nSe fizermos alterações significativas nesta política de privacidade que afetem o tratamento das informações pessoais dos usuários, forneceremos um aviso proeminente dentro do aplicativo ou enviaremos um aviso por e-mail. Ao continuar a utilizar o aplicativo após as alterações entrarem em vigor, você concordará com a nova política de privacidade.\n\nSe você não concordar com qualquer alteração nesta política de privacidade, você deve interromper o uso do aplicativo e, se aplicável, solicitar a exclusão de suas informações pessoais de acordo com a seção \"Direitos do Usuário\".\n\nAgradecemos que você revise regularmente esta política de privacidade para estar informado sobre como estamos protegendo suas informações.\n\n**Consentimento**\n\nAo utilizar nosso aplicativo, você concorda com a coleta, uso e compartilhamento de suas informações pessoais conforme descrito nesta política de privacidade.\n\n**Contato**\n\nCaso tenha alguma dúvida, preocupação ou solicitação relacionada à privacidade do seu uso do aplicativo, entre em contato conosco através dos canais de contato fornecidos no aplicativo.\n\n**Menores de idade**\n\nO nosso aplicativo não se destina a menores de idade. Não coletamos intencionalmente informações pessoais de crianças com idade inferior a 18 anos. Caso você seja o responsável legal de uma criança e tome conhecimento de que ela nos forneceu informações pessoais, entre em contato conosco imediatamente para que possamos tomar as medidas necessárias.\n\n**Jurisdição**\n\nEsta política de privacidade será regida e interpretada de acordo com as leis do Brasil e quaisquer disputas relacionadas a esta política estarão sujeitas à jurisdição exclusiva dos tribunais competentes nessa jurisdição."
    }
  };

  const plans = [
    {
      id: 'basico',
      title: 'Básico',
      description: 'Essencial para iniciantes na plataforma',
      price: 'R$ 39,90',
      period: '/mês',
      originalPrice: null,
      features: ['Exposição média na plataforma', 'Gestão de até 15 tutores e 50 pacientes'],
      // freeMonths: '2 meses grátis',
      lookupKey: 'alzan.vet.standard',
      // coupon: 'FREE_2',
      icon: <ChartIcon />,
      badge: null,
      weight: 2
    },
    {
      id: 'plus',
      title: 'Plus',
      description: 'Recomendado para clínicas em crescimento',
      price: 'R$ 79,90',
      period: '/mês',
      originalPrice: null,
      features: ['Exposição alta na plataforma', 'Sistema de agendamentos completo', 'Gestão de até 50 tutores e 150 pacientes'],
      // freeMonths: '2 meses grátis',
      lookupKey: 'alzan.vet.plus',
      // coupon: 'FREE_2',
      icon: <RocketIcon />,
      badge: null,
      weight: 1
    },
    {
      id: 'premium',
      title: 'Premium',
      description: 'Para profissionais que buscam destaque máximo',
      price: 'R$ 129,90',
      period: '/mês',
      originalPrice: null,
      features: ['Exposição máxima na plataforma', 'Sistema de agendamentos completo', 'Selo de destaque exclusivo', 'Gestão de até 100 tutores e 500 pacientes'],
      // freeMonths: '1 mês grátis',
      lookupKey: 'alzan.vet.premium',
      // coupon: 'FREE_1',
      isPremium: true,
      icon: <CrownIconLarge />,
      badge: null,
      weight: 0
    }
  ];

  const handleContinue = async () => {
    const plan = plans.find(p => p.id === selectedPlan);
    if (!plan) return;

    setIsLoading(true);
    setError('');

    try {
      const result = await billingService.createCheckoutSession(
        plan.lookupKey,
        user?.email || '',
        user?.entities?.[0]?.id || user?.entity_id || null,
        plan.coupon,
        plan.weight,
        plan.title
      );

      if (result.success && result.url) {
        // Redirecionar para o checkout do Stripe
        window.location.href = result.url;
      } else {
        setError('Erro ao processar pagamento. Tente novamente.');
      }
    } catch (err) {
      setError(err.message || 'Erro ao processar pagamento. Tente novamente.');
      setIsLoading(false);
    }
  };

  return (
    <div className="subscription-overlay">
      <div className="subscription-container">
        <button className="close-button" onClick={onClose} aria-label="Fechar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <div className="subscription-content">
          <div className="subscription-header">
            <h1 className="subscription-title">Planos de Assinatura</h1>
            <p className="subscription-subtitle">
              Escolha o plano ideal para o seu negócio e aumente sua visibilidade na plataforma
            </p>
          </div>

          <div className="plans-container">
            {plans.map(plan => (
              <PlanCard
                key={plan.id}
                title={plan.title}
                description={plan.description}
                price={`${plan.price}${plan.period}`}
                originalPrice={plan.originalPrice}
                features={plan.features}
                freeMonths={plan.freeMonths}
                isSelected={selectedPlan === plan.id}
                isPremium={plan.isPremium}
                badge={plan.badge}
                icon={plan.icon}
                onSelect={() => setSelectedPlan(plan.id)}
              />
            ))}
          </div>

          <div className="subscription-footer">
            {error && (
              <div className="subscription-error">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                  <path d="M12 8V12M12 16H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
                <span>{error}</span>
              </div>
            )}

            <button className="continue-button" onClick={handleContinue} disabled={isLoading}>
              {isLoading ? (
                <>
                  <div className="button-spinner"></div>
                  <span>Processando...</span>
                </>
              ) : (
                <span>Assinar Plano {plans.find(p => p.id === selectedPlan)?.title}</span>
              )}
            </button>

            {/* <div className="security-info">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>Transação segura e criptografada</span>
            </div> */}

            <div className="legal-links">
              <a href="#" className="legal-link" onClick={(e) => { e.preventDefault(); setLegalModal('privacyPolicy'); }}>Política de Privacidade</a>
              <span className="separator">•</span>
              <a href="#" className="legal-link" onClick={(e) => { e.preventDefault(); setLegalModal('termsOfUse'); }}>Termos de Serviço</a>
            </div>
          </div>
        </div>
      </div>

      {legalModal && (
        <div className="legal-modal-overlay" onClick={() => setLegalModal(null)}>
          <div className="legal-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="legal-modal-header">
              <h2>{legalContent[legalModal].title}</h2>
              <button className="legal-modal-close" onClick={() => setLegalModal(null)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
            <div className="legal-modal-body">
              {legalContent[legalModal].content.split('\n').map((paragraph, index) => {
                if (paragraph.trim().startsWith('**') && paragraph.trim().endsWith('**')) {
                  return <h3 key={index}>{paragraph.replace(/\*\*/g, '')}</h3>;
                }
                if (paragraph.trim() === '') {
                  return <br key={index} />;
                }
                return <p key={index}>{paragraph}</p>;
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscription;
